import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { basePspBranchEffects, basePspBranchReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('pspBranch', basePspBranchReducer.BasePspBranchReducer),
    EffectsModule.forFeature([basePspBranchEffects.BasePspBranchEffects]),
  ],
})
export class BasePspBranchStoreModule {}
